/* eslint-disable */
/**
 * Auto-generated by version-sw-urls.js (--write-version-only). Do not edit manually.
 */
export const SW_VERSION = '55b0d25b';
